"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.awarenessChannelMap = void 0;

var _userAwarenessChannelConstants = _interopRequireDefault(require("./userAwarenessChannelConstants"));

var _awarenessChannelMap;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var awarenessChannelMap = (_awarenessChannelMap = {}, _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.BLOGS_ARTICLES, {
  displayText: 'Blog or article'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.BOUGHT_GIFT, {
  displayText: 'Bought a gift on Zola'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.FACEBOOK, {
  displayText: 'Facebook'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.FRIEND_FAMILY, {
  displayText: 'Friends and family'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.GOOGLE_SEARCH, {
  displayText: 'Google search'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.INFLUENCER, {
  displayText: 'Influencers'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.INSTAGRAM, {
  displayText: 'Instagram'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.NEWS, {
  displayText: 'In the news'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.ONLINE_AD, {
  displayText: 'Ads while browsing the internet'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.OTHER, {
  displayText: 'Other'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.PINTEREST, {
  displayText: 'Pinterest'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.PODCAST, {
  displayText: 'Podcast'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.PUBLICATION, {
  displayText: 'News/article',
  isDisabled: true
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.SUBWAY, {
  displayText: 'Subway or billboard'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.TIKTOK, {
  displayText: 'TikTok'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.TV_COMMERCIAL, {
  displayText: 'Streaming service or TV (e.g. Hulu)'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.WEDDING_BLOG, {
  displayText: 'Wedding blog/forum',
  isDisabled: true
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.WEDDING_VENDOR, {
  displayText: 'Wedding vendor'
}), _defineProperty(_awarenessChannelMap, _userAwarenessChannelConstants.default.YOUTUBE, {
  displayText: 'YouTube'
}), _awarenessChannelMap);
exports.awarenessChannelMap = awarenessChannelMap;